import PropTypes from 'prop-types';
import { Layout } from 'antd';

const { Content } = Layout;

const ContentCustom = ({ children, padding, style }) => {
  return (
    <Content
      style={{
        paddingTop: padding ? 24 : 24,
        paddingLeft: '35px',
        paddingRight: '35px',
        paddingBottom: 24,
        background: 'var(--bodyBackground)',
        overflow: 'hidden',
        ...style
      }}
    >
      {children}
    </Content>
  );
};

ContentCustom.propTypes = {
  padding: PropTypes.bool,
  style: PropTypes.shape({})
};

ContentCustom.defaultProps = {
  padding: true,
  style: undefined
};

export default ContentCustom;
